/*eslint-disable*/
import React, { useState, useEffect, useContext, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Email from "@material-ui/icons/Email";
import Person from "@material-ui/icons/PersonOutline";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import CustomInputWithValidation from "components/CustomInput/CustomInputWithValidation";
import styles from "assets/jss/material-kit-react/views/loginPage.js";
import image from "assets/img/bg24.jpg";
import { useSelector, useDispatch } from "react-redux";
import { Paper, Select, MenuItem, Tab, Tabs, LinearProgress } from "@material-ui/core";
import PhoneIcon from "@material-ui/icons/Phone";
import AlertDialog from "../components/AlertDialog";
import CountrySelect from "../components/CountrySelect";
import IdentityCountrySelect from "../components/IdentityCountrySelect";

import { language, default_country_code, features } from "config";
import { FirebaseContext } from "common";
import { Input, Label, FormGroup, Row, Col, FormText } from "reactstrap";
// import { Stats } from "fs";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import PasswordChecklist from "react-password-checklist";
import { useNavigate } from "react-router-dom";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";


const useStyles = makeStyles(styles);

export default function RegisterPage(props) {
  const { api } = useContext(FirebaseContext);
  const {
    clearLoginError,
    emailSignUp,
    checkUserExists,
    validateReferer,
    createOpenfireUser,
    fetchUsers,
  } = api;
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const openfireuser = useSelector(
    (state) => state.openfireuserdata.openfireuser
  );
  const navigate = useNavigate();
  const [fileState, setFileState] = useState(null);
  const [fileState1, setFileState1] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(props.avatar);
  const [imagePreviewUrl1, setImagePreviewUrl1] = useState(props.avatar);
  const fileInput = useRef();
  const fileInput1 = useRef();
  const [userName, setuserName] = useState(" ");
  const [progress, setProgress] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [countryCode, setCountryCode] = useState(default_country_code);

  const [mobileWithoutCountry, setMobileWithoutCountry] = useState("");

  const [hasReferralId, setHasReferralId] = useState(false);

  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const { ...rest } = props;
  const doctortypes = useSelector((state) => state.doctortypes.doctorstypes);
  const specialities = useSelector(
    (state) => state.specialitytypes.specialities
  );
  const [specialityTypes, setSpecialityTypes] = useState([]);
  const [doctorTypes, setDoctorTypes] = useState([]);

  const [state, setState] = useState({
    userType: "patient",
    email: "",
    firstName: "",
    lastName: "",
    username: "",
    identityNumber: "",
    identityNumberType: "",
    isIndependent: true,
    referralId: "",
    practiceNumber: "",
    practiceName: "",
    practiceLicenseNumber: "",
    specialityType: false,
    doctorType: "General Practioner" || false,
    bankAccount: "",
    bankCode: "",
    bankName: "",
    bankType: false,
    licenseImage: null,
    doctorImage: null,
    nurseImage: null,
    other_info: "",
    password: "",
    newUser: true,
    PracticeAdminRights: true,
  });
  const saBanks = [
    { label: "Absa Bank", value: "Absa Bank" },
    { label: "Capitec Bank", value: "Capitec Bank" },
    { label: "First National Bank", value: "First National Bank" },
    { label: "Investec Bank", value: "Investec Bank" },
    { label: "Nedbank", value: "Nedbank" },
    { label: "Standard Bank", value: "Standard Bank" },
    { label: "TymeBank", value: "TymeBank" },
    { label: "African Bank", value: "African Bank" },
  ];

  const [fieldErrors, setFieldErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    mobile: '',
    identityNumberType: '',
    identityNumber: '',
    practiceName: '',
    specialityType: '',
    practiceNumber: '',
    practiceLicenseNumber: '',
  });

  const [showPassword, setShowPassword] = useState(false);

  const [IdType, setIdType] = useState("ZA");

  const [selectedSpecialityDetails, setSelectedSpecialityDetails] =
    useState("FAMILY MEDICINE");
  const [selectedDoctorTypeDetails, setSelectedDoctorTypeDetails] =
    useState("GENERAL_PRACTIONER");
  const [isSubmitted, setIsSubmitted] = useState(false);


  useEffect(() => {
    if (specialities) {
      let arr = [];
      for (let i = 0; i < Object.keys(specialities).length; i++) {
        arr.push({
          value: Object.keys(specialities)[i],
          label: Object.values(specialities)[i],
        });
      }
      setSpecialityTypes(arr);

      const hasSelected = arr.some((s) => s.value === selectedSpecialityDetails);
      if (!hasSelected && arr.length) {
        // find by label case-insensitively (matches "Family Medicine")
        const def = arr.find((s) => /family medicine/i.test(s.label));
        if (def) {
          setSelectedSpecialityDetails(def.value);
          setState((prev) => ({ ...prev, specialityType: def.value }));
        }
      }
    }

    if (doctortypes) {
      let arr = [];
      for (let i = 0; i < Object.keys(doctortypes).length; i++) {
        arr.push({
          label: Object.values(doctortypes)[i],
          value: Object.keys(doctortypes)[i],
        });
      }
      setDoctorTypes(arr);
    }
  }, [doctortypes, specialities, selectedSpecialityDetails]);




  useEffect(() => {
    let intervalId = null;

    if (isLoading) {
      setShowLoader(true);
      setProgress(5);
      intervalId = setInterval(() => {
        setProgress((p) => {

          const next = Math.min(90, p + Math.floor(Math.random() * 10) + 5);
          return next;
        });
      }, 250);
    } else if (showLoader) {

      setProgress(100);

      const t = setTimeout(() => {
        setShowLoader(false);
        setProgress(0);
      }, 450);

      if (intervalId) clearInterval(intervalId);
      return () => clearTimeout(t);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [isLoading]);



  const handleSpecialitySelect = (event) => {
    let specialityDetails = null;
    for (let i = 0; i < Object.keys(specialities).length; i++) {
      if (Object.keys(specialities)[i] === event.target.value) {
        specialityDetails = Object.keys(specialities)[i];
      }
    }
    setState({ ...state, specialityType: event.target.value });
    console.log("this is the speciality details: ", specialityDetails);
    setSelectedSpecialityDetails(specialityDetails);
  };
  const handleBankType = (event) => {
    setState({ ...state, bankType: event.target.value });
  };
  const handleDoctorSelect = (event) => {
    let doctorTypeDetails = null;
    for (let i = 0; i < Object.keys(doctortypes).length; i++) {
      if (Object.keys(doctortypes)[i] === event.target.value) {
        doctorTypeDetails = Object.keys(doctortypes)[i];
      }
    }
    setState({ ...state, doctorType: event.target.value });
    console.log("this is the doctor details: ", doctorTypeDetails);
    setSelectedDoctorTypeDetails(doctorTypeDetails);
  };
  const onReferral = (evant) => {
    setState({
      ...state,
      [event.target.id]: event.target.value,
      username:
        state.firstName +
        state.lastName +
        Math.floor(1000 + Math.random() * 9000).toString(),
    });
  }
  const onInputChange = (event) => {

    setState({
      ...state,
      [event.target.id]: event.target.value,
      username:
        state.firstName +
        state.lastName +
        Math.floor(1000 + Math.random() * 9000).toString(),
    });
  };


  const validateField = (fieldName, value) => {
    const newErrors = { ...fieldErrors };

    switch (fieldName) {
      case 'firstName':
        newErrors.firstName = value.length > 0 ? '' : 'Please input a First Name';
        break;
      case 'lastName':
        newErrors.lastName = value.length > 0 ? '' : 'Please input a Last Name';
        break;
      case 'email':
        const emailRegex = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        newErrors.email = emailRegex.test(value) ? '' : 'Please enter a valid email address';
        break;
      case 'mobile':
        newErrors.mobile = validateMobile() ? '' : 'Please enter a valid mobile number';
        break;
      case 'identityNumberType':
        newErrors.identityNumberType = value ? '' : 'Please select the country your identity number originates from';
        break;
      case 'identityNumber':
        if (/[.-]/.test(value)) {
          newErrors.identityNumber = 'Please remove dots or dashes from the Identity number';
        } else {
          newErrors.identityNumber = value ? '' : 'Please enter a valid Identity number';
        }
        break;
      default:
        break;
    }

    setFieldErrors(newErrors);
    return newErrors[fieldName] === '';
  };

  const clearFieldError = (fieldName) => {
    setFieldErrors(prev => ({
      ...prev,
      [fieldName]: ''
    }));
  };

  const validateMobile = () => {
    let mobileValid = true;
    if (mobileWithoutCountry.length < 6) {
      mobileValid = false;
      // setCommonAlert({ open: true, msg: language.mobile_no_blank_error });
    }
    if (
      mobileWithoutCountry.includes("+") ||
      mobileWithoutCountry.includes(" ") ||
      mobileWithoutCountry.includes("-")
    ) {
      mobileValid = false;
      setCommonAlert({ open: true, msg: language.mobile_no_blank_error });
    }
    return mobileValid;
  };

  const handleRemove = () => {
    fileInput.current.value = null;
    setFileState(null);
    setImagePreviewUrl(props.avatar);
  };
  const handleRemove1 = () => {
    fileInput1.current.value = null;
    setFileState1(null);
    setImagePreviewUrl1(props.avatar);
  };

  const handleClick = () => {
    fileInput.current.click();
  };
  const handleClick1 = () => {
    fileInput1.current.click();
  };
  const handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];

    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      setCommonAlert({
        open: true,
        msg: "File size exceeds 10MB limit. Please choose a smaller file."
      });
      return;
    }

    const allowedTypes = [
      'image/png', 'image/jpeg', 'image/jpg', 'image/bmp', 'image/tiff', 'image/webp',
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'text/plain',
      'application/rtf',
      'application/vnd.oasis.opendocument.text'
    ];

    if (!allowedTypes.includes(file.type)) {
      setCommonAlert({
        open: true,
        msg: "File type not supported. Please upload PNG, JPG, PDF, DOC, DOCX, or TXT files."
      });
      return;
    }

    reader.onloadend = async () => {
      setFileState(file);
      setState({ ...state, licenseImage: file });
      if (file.type.startsWith('image/')) {
        setImagePreviewUrl(reader.result);
      }
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };
  // const handleImageChange = (e) => {
  //   e.preventDefault();
  //   let reader = new FileReader();
  //   // console.log("the reader", reader);
  //   let file = e.target.files[0];
  //   // console.log("the file", file);
  //   reader.onloadend = async () => {
  //     setFileState(file);
  //     console.log("the fileState results ", reader);

  //     setState({ ...state, licenseImage: file });

  //     setImagePreviewUrl(reader.result);
  //   };
  //   if (file) {
  //     reader.readAsDataURL(file);
  //     console.log("We made it here:", file);
  //   }
  // };
  const handleImageChange1 = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    // console.log("the reader", reader);
    let file = e.target.files[0];
    // console.log("the file", file);
    reader.onloadend = () => {
      setFileState1(file);
      console.log("the fileState results ", reader);
      if (state.userType === "nurse") {
        setState({ ...state, nurseImage: file });
      } else if (state.userType === "doctor") {
        setState({ ...state, doctorImage: file });
      }
      setImagePreviewUrl1(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
      console.log("We made it here:", file);
    }
  };
  const validatePractice = () => {
    let practiceValid = true;

    if (state.userType === "patient") {
      practiceValid = true;
      // Alert.alert('you are registering as a patient');
    } else {
      if (
        (state.specialityType === false ||
          state.specialityType === "" ||
          state.specialityType === null) &&
        (state.doctorType === false ||
          state.doctorType === " " ||
          state.doctorType === null)
      ) {
        return practiceValid = false;
        // setCommonAlert({ open: true, msg: "Please select practice type" });
      }
    }
    return practiceValid;
  };
  const validatePassword = (complexity) => {
    let passwordValid = true;
    const regx1 = /^([a-zA-Z0-9@*#]{8,15})$/;
    const regx2 =
      /(?=^.{5,1000}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*()_+}{&quot;:;'?/&gt;.&lt;,])(?!.*\s).*$/;
    if (complexity === "any") {
      passwordValid = state.password.length >= 1;
      if (!passwordValid) {
        // setCommonAlert({ open: true, msg: language.password_blank_messege });
        return passwordValid = false;
      }
    } else if (complexity === "alphanumeric") {
      passwordValid = regx1.test(state.password);
      if (!passwordValid) {
        // setCommonAlert({
        //   open: true,
        //   msg: language.password_alphaNumeric_check,
        // });
        return passwordValid = false;
      }
    } else if (complexity === "complex") {
      passwordValid = regx2.test(state.password);
      if (!passwordValid) {
        // setCommonAlert({ open: true, msg: language.password_complexity_check });
        return passwordValid = false;
      }
    }
    return passwordValid;
  };
  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };
  const openFireUserDetails = () => {
    setOpen(false);
    setTimeout(() => {
      navigate("/login");
    }, 3000);
  };





  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };
  const handleBack = (e) => {
    e.preventDefault();
    navigate("/login");
  };



  const handleRegister = (e) => {
    e.preventDefault();
    setIsLoading(true);

    setFieldErrors({});

    let hasErrors = false;
    const newErrors = { ...fieldErrors };

    if (!(state.firstName.length > 0)) {
      newErrors.firstName = "Please input a First Name";
      hasErrors = true;
    }

    if (!(state.lastName.length > 0)) {
      newErrors.lastName = "Please input a Last Name";
      hasErrors = true;
    }

    const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[[a-zA-Z]{2,}))$/;
    if (!re.test(state.email)) {
      newErrors.email = language.valid_email_check;
      hasErrors = true;
    }

    if (validatePassword("complex") === false) {
      newErrors.password = "Please check password requirements";
      hasErrors = true;
    }

    if (!validateMobile()) {
      newErrors.mobile = "Please enter a valid mobile number";
      hasErrors = true;
    }

    if (state.identityNumberType === "") {
      setState({
        ...state,
        identityNumberType: "ZA"
      });
      console.log("No country selected, defaulting to ZA");
    }

    if (/[.-]/.test(state.identityNumber)) {
      newErrors.identityNumber = "Please remove dots or dashes from the Identity number";
      hasErrors = true;
    }

    if (state.identityNumber === "") {
      newErrors.identityNumber = "Please enter a valid Identity number";
      hasErrors = true;
    }

    if (!(state.userType === "patient")) {
      if (validatePractice() === false) {
        newErrors.practiceType = "Please select practice type";
        hasErrors = true;
      }

      if (state.practiceName === "") {
        newErrors.practiceName = "Please enter a valid practice name";
        hasErrors = true;
      }

      if (!state.specialityType) {
        newErrors.specialityType = "Please enter a valid speciality type";
        hasErrors = true;
      }

      if (state.practiceNumber === "") {
        newErrors.practiceNumber = "Please enter a valid practice number";
        hasErrors = true;
      }

      if (state.practiceLicenseNumber === "") {
        newErrors.practiceLicenseNumber = "Please enter a valid MP number";
        hasErrors = true;
      }
    }



    if (hasErrors) {
      setFieldErrors(newErrors);
      setIsLoading(false);

      // Optional: Scroll to first error
      const firstErrorField = Object.keys(newErrors).find(key => newErrors[key]);
      if (firstErrorField) {
        const element = document.getElementById(firstErrorField);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          element.focus();
        }
      }

      return;
    }


    checkUserExists(state).then((res) => {
      if (res.users && res.users.length > 0) {
        setCommonAlert({ open: true, msg: language.user_exists });
        setIsLoading(false);
      } else if (res.error) {
        setCommonAlert({
          open: true,
          msg: language.email_or_mobile_issue,
        });
        setIsLoading(false);
      } else {
        if (state.referralId && state.referralId.length > 0) {
          validateReferer(state.referralId)
            .then((referralInfo) => {
              if (referralInfo.uid && referralInfo.pnum) {
                emailSignUp({
                  ...state,
                  signupViaReferral: referralInfo.uid,
                  practiceNumber: referralInfo.pnum
                }).then((res) => {
                  console.log("the res after signup with referral", res);
                  if (res.uid) {
                    setCommonAlert({
                      open: true,
                      msg: language.account_create_successfully,
                    });
                    setTimeout(() => {
                      // navigate("/login");
                      console.log(state);
                    }, 3000);
                  } else {
                    setCommonAlert({
                      open: true,
                      msg: language.reg_error,
                    });
                  }
                  setIsLoading(false);
                });
              } else if (referralInfo.uid && !referralInfo.pnum) {
                emailSignUp({
                  ...regData,
                  signupViaReferral: referralInfo.uid
                }).then((res) => {
                  setIsLoading(false);
                  if (res.uid) {
                    Alert.alert(
                      language.alert,
                      language.account_create_successfully
                    );
                    props.navigation.navigate("LoginScreen");
                  } else {
                    Alert.alert(language.alert, language.reg_error);
                  }
                });

              } else {
                setCommonAlert({
                  open: true,
                  msg: language.referer_not_found,
                });
                setIsLoading(false);
              }
            })
            .catch((error) => {
              setCommonAlert({
                open: true,
                msg: language.referer_not_found,
              });
              setIsLoading(false);
            });
        } else {
          emailSignUp(state).then((res) => {
            console.log("Normal sign up response:", res);
            if (res?.code && res?.message) {
              setCommonAlert({
                open: true,
                msg: "An error occurred during registration. Please try again. " + res.code,
              });
            }
            // dispatch(
            //   createOpenfireUser(
            //     state.username,
            //     state.password,
            //     state.firstName,
            //     state.lastName,
            //     state.email
            //   )
            // );

            if (res.uid) {
              setCommonAlert({
                open: true,
                msg: "Account created successfully ",
              });
              setTimeout(() => {
                setIsLoading(false);
                setOpen(true);
              }, 3000);
            } else {
              setCommonAlert({
                open: true,
                msg: language.reg_error,
              });
              setIsLoading(false);
            }
          });
        }
      }
    });
  };

  return (
    <div>
      <Header
        absolute
        color="transparent"
        rightLinks={<HeaderLinks />}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center",
        }}
      >
        <div id="sign-in-button" />
        <div className={classes.container}>


          {/* Centered overlay loading bar */}
          {showLoader && (
            <div
              role="status"
              aria-live="polite"
              style={{
                position: "fixed",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 3000,
                background: "rgba(0,0,0,0.45)" // soft backdrop
              }}
            >
              <div
                style={{
                  width: "min(560px, 92%)",
                  padding: 22,
                  borderRadius: 12,
                  background: "linear-gradient(180deg, #ffffff, #f7fbff)",
                  boxShadow: "0 14px 40px rgba(2,6,23,0.45)",
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                  alignItems: "center",
                  border: "1px solid rgba(2,6,23,0.06)"
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 6 }}>
                    Creating account — please wait
                  </div>
                  <div style={{ fontSize: 13, color: "#445", marginBottom: 8 }}>
                    We're creating your account and securing your data. This usually takes a few seconds.
                  </div>
                </div>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 16,
                  width: "100%",
                  maxWidth: 480
                }}>
                  <div style={{ flex: 1 }}>
                    <LinearProgress variant="determinate" value={progress} aria-valuenow={Math.round(progress)} aria-valuemin={0} aria-valuemax={100} />
                  </div>
                  <div style={{ minWidth: 64, textAlign: "right" }}>
                    <div style={{ fontWeight: 700, fontSize: 16 }}>{Math.round(progress)}%</div>
                    <div style={{ fontSize: 11, color: "#6b7280" }} aria-hidden>
                      {progress < 30 ? 'Starting...' : progress < 70 ? 'Processing...' : progress < 100 ? 'Finalizing...' : 'Done'}
                    </div>
                  </div>
                </div>
                <div style={{ width: "100%", maxWidth: 480, display: "flex", justifyContent: "space-between", marginTop: 6 }}>
                  <div style={{ fontSize: 12, color: "#6b7280" }}>
                    Email: <strong style={{ color: '#111' }}>{state.email || '—'}</strong>
                  </div>
                  <div style={{ fontSize: 12, color: "#6b7280" }}>
                    Account type: <strong style={{ color: '#111' }}>{state.userType}</strong>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/*  */}
          <Modal
            isOpen={open}
            toggle={() => setOpen(false)}
            centered={true}
            size="lg"
          >
            <ModalHeader>
              This is your login details. Please save your information.
            </ModalHeader>

            <ModalBody>
              <FormGroup>
                <Label>Email:</Label>
                <div>{state.email}</div>
              </FormGroup>

              <FormGroup>
                <Label>Password:</Label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Input
                    type={showPassword ? "text" : "password"}
                    value={state.password}
                    readOnly
                  />
                  <Button
                    color="primary"
                    onClick={togglePasswordVisibility}
                    style={{ marginLeft: "8px" }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </Button>
                </div>
              </FormGroup>
            </ModalBody>

            <ModalFooter>
              <Button color="primary" onClick={() => navigate("/login")}>
                Continue
              </Button>
            </ModalFooter>
          </Modal>
          {/*  */}


          <GridContainer justifyContent="center">
            <GridItem xs={12} sm={12} md={5}>
              <Card>
                <form className={classes.form}>
                  <Paper
                    square
                    className={classes.root}
                    style={{
                      paddingTop: 20,
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Tabs
                      value={0}
                      variant="fullWidth"
                      indicatorColor="secondary"
                      textColor="inherit"
                      aria-label="switch login type"
                    >
                      <Tab
                        disabled={true}
                        label="Register"
                        aria-label="email"
                      />
                    </Tabs>
                  </Paper>
                  <CardBody>
                    <CustomInput
                      labelText={language.firstname + language.required}
                      id="firstName"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "text",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Person className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}

                      // isSubmitted ={isSubmitted}
                      onChange={(e) => {
                        onInputChange(e);
                        clearFieldError('firstName')
                      }}
                      value={state.firstName}
                      error={!!fieldErrors.firstName}
                    />
                    {fieldErrors.firstName && (
                      <FormText color="danger" style={{ fontSize: '12px', marginTop: '4px' }}>
                        {fieldErrors.firstName}
                      </FormText>
                    )}

                    <CustomInput // LAST NAME
                      labelText={language.lastname + language.required}
                      id="lastName"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "text",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Person className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => {
                        onInputChange(e);
                        clearFieldError('lastName')
                      }}
                      value={state.lastName}
                      error={!!fieldErrors.lastName}
                    />
                    {fieldErrors.lastName && (
                      <FormText color="danger" style={{ fontSize: '12px', marginTop: '4px' }}>
                        {fieldErrors.lastName}
                      </FormText>
                    )}

                    {/* //email */}
                    <CustomInput
                      labelText={language.email + language.required}
                      id="email"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "email",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Email className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => {
                        onInputChange(e);
                        clearFieldError('email')
                      }}
                      error={!!fieldErrors.email}
                      value={state.email}

                    />
                    {fieldErrors.email && (
                      <FormText color="danger" style={{ fontSize: '12px', marginTop: '4px' }}>
                        {fieldErrors.email}
                      </FormText>
                    )}


                    {/* passwod */}
                    <CustomInput
                      labelText={language.password + language.required}
                      id="password"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "password",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icon className={classes.inputIconsColor}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        ),
                        autoComplete: "off",
                      }}
                      onChange={(e) => {
                        onInputChange(e);
                        clearFieldError('password')
                      }}
                      value={state.password}
                      error={!!fieldErrors.password}
                    />
                    {fieldErrors.password && (
                      <FormText color="danger" style={{ fontSize: '12px', marginTop: '4px' }}>
                        {fieldErrors.password}
                      </FormText>
                    )}
                    <FormGroup
                    // hidden="true"
                    >
                      <PasswordChecklist
                        rules={[
                          "minLength",
                          "specialChar",
                          "number",
                          "capital",
                          // "match",
                        ]}
                        minLength={8}
                        value={state.password}
                        valueAgain={state.password}
                        onChange={(isValid) => { }}
                      />
                    </FormGroup>



                    {features.AllowCountrySelection ? ( // COUNTRY
                      <CountrySelect
                        value={countryCode}
                        onChange={(object, value) => {
                          setCountryCode(value);
                          let formattedNum = mobileWithoutCountry.replace(
                            / /g,
                            ""
                          );
                          formattedNum =
                            "+" + value.phone + formattedNum.replace(/-/g, "");
                          setState({ ...state, mobile: formattedNum });
                        }}
                        style={{ paddingTop: 20 }}
                        disabled={state.verificationId ? true : false}
                      />



                    ) : null}


                    <CustomInput
                      labelText={language.phone + language.required}
                      id="mobile"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        required: true,
                        disabled: state.verificationId ? true : false,
                        endAdornment: (
                          <InputAdornment position="end">
                            <PhoneIcon className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(event) => {
                        setMobileWithoutCountry(event.target.value);
                        let formattedNum = event.target.value.replace(/ /g, "");
                        formattedNum =
                          "+" +
                          countryCode.phone +
                          formattedNum.replace(/-/g, "");
                        setState({ ...state, mobile: formattedNum });
                        clearFieldError('mobile')
                      }}
                      value={mobileWithoutCountry}
                      error={!!fieldErrors.mobile}
                    />
                    {fieldErrors.mobile && (
                      <FormText color="danger" style={{ fontSize: '12px', marginTop: '4px' }}>
                        {fieldErrors.mobile}
                      </FormText>
                    )}

                    <IdentityCountrySelect
                      value={IdType}
                      onChange={(newValue) => {
                        setIdType(newValue);
                        setState((prev) => ({
                          ...prev,
                          identityNumberType: newValue?.label || "",
                        }));
                      }}
                      style={{ paddingTop: 20 }}
                      disabled={state.verificationId ? true : false}
                    />




                    <CustomInput
                      labelText={language.identity_number_placeholder + language.required}
                      id="identityNumber"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "String",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Email className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => {
                        onInputChange(e);
                        clearFieldError('identityNumber')
                      }}
                      value={state.identityNumber}
                      error={!!fieldErrors.identityNumber}
                    />
                    {fieldErrors.identityNumber && (
                      <FormText color="danger" style={{ fontSize: '12px', marginTop: '4px' }}>
                        {fieldErrors.identityNumber}
                      </FormText>
                    )}



                    {/* <IdentityCountrySelect
                      value={countryCode}
                      onChange={(object, value) => {
                        setCountryCode(value);
                        setState((prev) => ({
                          ...prev,
                          identityNumberType: value.label, // Set to selected country name
                        }));
                      }}
                      style={{ paddingTop: 20 }}
                      disabled={state.verificationId ? true : false}
                    />

                    
                    <CustomInput
                      labelText={language.identity_number_placeholder + language.required}
                      id="identityNumber"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "number",
                        required: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Email className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                      onChange={onInputChange}
                      value={state.identityNumber}
                    /> */}
                    <FormGroup>
                      <Label>Have you been referred by another doctor?</Label>
                      <Select
                        value={hasReferralId}
                        onChange={(e) => setHasReferralId(e.target.value)}
                        fullWidth
                      >
                        <MenuItem value={false}>No, I have not been reffered</MenuItem>
                        <MenuItem value={true}>Yes, I have been reffered and have a refferal id </MenuItem>
                      </Select>
                    </FormGroup>


                    {/* Conditionally show referral ID input */}
                    {hasReferralId && (
                      <CustomInput
                        labelText={"Please enter your referral ID here"}
                        id="referralId"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          required: false,
                          endAdornment: (
                            <InputAdornment position="end">
                              <Email className={classes.inputIconsColor} />
                            </InputAdornment>
                          ),
                        }}
                        onChange={onInputChange}
                        value={state.referralId}
                      />
                    )}


                    <FormGroup className="form-check form-check-radio form-check-inline">
                      <Label check>
                        <Input
                          value="patient"
                          id="patient"
                          name="userType"
                          type="radio"
                          onChange={handleChange}
                        ></Input>
                        Patient <span className="form-check-sign"></span>
                      </Label>
                    </FormGroup>
                    <FormGroup className="form-check form-check-radio form-check-inline">
                      <Label check>
                        <Input
                          value="doctor"
                          id="doctor"
                          name="userType"
                          type="radio"
                          onChange={handleChange}
                        ></Input>
                        Doctor <span className="form-check-sign"></span>
                      </Label>
                    </FormGroup>
                    <FormGroup className="form-check form-check-radio form-check-inline">
                      <Label check>
                        <Input
                          value="nurse"
                          id="nurse"
                          name="userType"
                          type="radio"
                          onChange={handleChange}
                        ></Input>
                        Nurse <span className="form-check-sign"></span>
                      </Label>
                    </FormGroup>


                    {/* Doctor And Nurse */}
                    {state.userType !== "patient" ? (
                      <>
                        <CustomInput
                          labelText={language.practice_name + language.required}
                          id="practiceName"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: "text",
                            required: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <Email className={classes.inputIconsColor} />
                              </InputAdornment>
                            ),
                          }}
                          onChange={(e) => {
                            onInputChange(e);
                            clearFieldError('practiceName')
                          }}
                          value={state.practiceName}
                          error={!!fieldErrors.practiceName}
                        />
                        {fieldErrors.practiceName && (
                          <FormText color="danger" style={{ fontSize: '12px', marginTop: '4px' }}>
                            {fieldErrors.practiceName}
                          </FormText>
                        )}
                      </>
                    ) : null}


                    {/* {state.userType !== "patient" ? (
                      <>
                        <Label>Speciality Types ( required ) </Label>
                        <>
                          <Select
                            id="practice-type-native"
                            value={selectedSpecialityDetails}
                            onChange={handleSpecialitySelect}
                            variant="outlined"
                            fullWidth
                            className={
                              specialityTypes === language.select_practice
                                ? classes.inputdimmed
                                : classes.input
                            }
                          >
                            {specialityTypes.map((special) => (
                              <MenuItem value={special.value}>
                                {special.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </>
                      </>
                    ) : null} */}
                    {/* {state.userType !== "patient" ? (
                      <>
                        <Label>Doctor Type ( required )</Label>
                        <Select
                          id="speciality-type-native"
                          value={selectedDoctorTypeDetails} // This will now match "GENERAL_PRACTIONER"
                          onChange={handleDoctorSelect}
                          variant="outlined"
                          fullWidth
                          className={
                            doctorTypes === language.select_speciality ? classes.inputdimmed : classes.input
                          }
                        >
                          {doctorTypes.map((doctor) => (
                            <MenuItem key={doctor.value} value={doctor.value}>
                              {doctor.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </>
                    ) : null} */}

                    {state.userType !== "patient" ? (
                      <>
                        <FormGroup>
                          <Label>Speciality Types (required)</Label>
                          <Autocomplete
                            id="speciality-type-autocomplete"
                            options={specialityTypes}
                            getOptionLabel={(option) => option.label}
                            value={specialityTypes.find((s) => s.value === selectedSpecialityDetails) || null}
                            onChange={(event, newValue) => {
                              if (newValue) {
                                setSelectedSpecialityDetails(newValue.value);
                                setState((prev) => ({ ...prev, specialityType: newValue.value }));
                                clearFieldError('specialityType');
                              }
                            }}
                            onBlur={() => validateField('specialityType', state.specialityType)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                fullWidth
                                placeholder="Select or search speciality type"
                                error={!!fieldErrors.specialityType}
                                helperText={fieldErrors.specialityType}
                                className={
                                  specialityTypes === language.select_practice ? classes.inputdimmed : classes.input
                                }
                              />
                            )}
                          />
                        </FormGroup>
                      </>
                    ) : null}


                    {state.userType !== "patient" ? (
                      <>
                        <Label>Doctor Type (required)</Label>
                        <Autocomplete
                          id="doctor-type-autocomplete"
                          options={doctorTypes}
                          getOptionLabel={(option) => option.label}
                          value={doctorTypes.find((d) => d.value === selectedDoctorTypeDetails) || null}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              setSelectedDoctorTypeDetails(newValue.value);
                              setState((prev) => ({ ...prev, doctorType: newValue.value }));

                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              fullWidth
                              placeholder="Select or search doctor type"

                              className={
                                doctorTypes === language.select_speciality ? classes.inputdimmed : classes.input
                              }
                            />
                          )}
                        />
                      </>
                    ) : null}


                    {state.userType !== "patient" ? (
                      <>
                        <CustomInput
                          labelText={"Practice number ( Registered number with BHF )"}
                          id="practiceNumber"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: "text",
                            required: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <Email className={classes.inputIconsColor} />
                              </InputAdornment>
                            ),
                          }}
                          onChange={(e) => {
                            onInputChange(e);
                            clearFieldError('practiceNumber');
                          }}
                          value={state.practiceNumber}
                          error={!!fieldErrors.practiceNumber}
                        />
                        {fieldErrors.practiceNumber && (
                          <FormText color="danger" style={{ fontSize: '12px', marginTop: '4px' }}>
                            {fieldErrors.practiceNumber}
                          </FormText>
                        )}
                      </>
                    ) : null}


                    {state.userType !== "patient" ? (
                      <Col>
                        <Row>
                          <FormGroup>
                            {state.userType !== "patient" && state.userType !== "nurse" ? (

                              <FormText color="red" tag="header" style={{ marginBottom: '15px' }}>
                                Upload practice license image <em>(Accepted: PNG, JPG, JPEG, PDF, DOC, DOCX, TXT. Max 10MB)</em>
                              </FormText>
                            ) : state.userType !== "patient" && state.userType !== "doctor" ? (
                              <FormText color="red" tag="header" style={{ marginBottom: '15px' }}>
                                Annual Practice Certificate <em>(Accepted: PNG, JPG, JPEG, PDF, DOC, DOCX, TXT. Max 10MB)</em>
                              </FormText>
                            ) : null}

                            <div className="fileinput text-center" style={{ marginBottom: '20px' }}>
                              <input
                                type="file"
                                onChange={handleImageChange}
                                ref={fileInput}
                                accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .txt"
                                style={{ display: 'none' }}
                              />

                              {/* Only show preview when file is selected */}
                              {fileState && (
                                <div style={{
                                  marginBottom: '15px',
                                  padding: '10px',
                                  border: '1px solid #e0e0e0',
                                  borderRadius: '8px',
                                  backgroundColor: '#fafafa'
                                }}>
                                  {fileState.type.startsWith('image/') ? (
                                    <div style={{ textAlign: 'center' }}>
                                      <img
                                        src={imagePreviewUrl}
                                        alt="Document preview"
                                        style={{
                                          maxWidth: '200px',
                                          maxHeight: '150px',
                                          borderRadius: '4px'
                                        }}
                                      />
                                      <div style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
                                        {fileState.name}
                                      </div>
                                    </div>
                                  ) : (
                                    <div style={{
                                      textAlign: 'center',
                                      padding: '15px'
                                    }}>
                                      <div style={{
                                        fontSize: '36px',
                                        marginBottom: '8px',
                                        color: '#1976d2'
                                      }}>
                                        📄
                                      </div>
                                      <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                                        {fileState.name}
                                      </div>
                                      <div style={{ fontSize: '12px', color: '#666' }}>
                                        {fileState.type || 'Document file'} • {(fileState.size / 1024 / 1024).toFixed(2)} MB
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}

                              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                                {!fileState ? (
                                  <Button
                                    className="btn-round"
                                    onClick={() => handleClick()}
                                    style={{ minWidth: '140px' }}
                                  >
                                    Select File
                                  </Button>
                                ) : (
                                  <>
                                    <Button
                                      className="btn-round"
                                      onClick={() => handleClick()}
                                      style={{ minWidth: '120px' }}
                                    >
                                      Change File
                                    </Button>
                                    <Button
                                      color="danger"
                                      className="btn-round"
                                      onClick={() => handleRemove()}
                                      style={{ minWidth: '120px' }}
                                    >
                                      <i className="fa fa-times" />
                                      Remove
                                    </Button>
                                  </>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </Row>
                      </Col>
                    ) : null}

                    {state.userType !== "patient" && state.userType !== "nurse" ? (
                      <>
                        <CustomInput
                          labelText={"Medical Practitioner number ( Registration with HPCSA )"}
                          id="practiceLicenseNumber"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: "text",
                            required: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <Email className={classes.inputIconsColor} />
                              </InputAdornment>
                            ),
                          }}
                          onChange={(e) => {
                            onInputChange(e);
                            clearFieldError('practiceLicenseNumber');
                          }}
                          value={state.practiceLicenseNumber}
                          error={!!fieldErrors.practiceLicenseNumber}
                        />
                        {fieldErrors.practiceLicenseNumber && (
                          <FormText color="danger" style={{ fontSize: '12px', marginTop: '4px' }}>
                            {fieldErrors.practiceLicenseNumber}
                          </FormText>
                        )}
                      </>
                    ) : null}

                    {state.userType !== "patient" &&
                      state.userType !== "doctor" ? (
                      <CustomInput
                        labelText={"Annual Practice Certificates ( required )"}
                        id="practiceLicenseNumber"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          required: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <Email className={classes.inputIconsColor} />
                            </InputAdornment>
                          ),
                        }}
                        onChange={onInputChange}
                        value={state.practiceLicenseNumber}
                      />
                    ) : null}
                    {state.userType !== "patient" ? (
                      <CustomInput
                        labelText={language.other_info}
                        id="other_info"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          required: true,
                        }}
                        onChange={onInputChange}
                        value={state.other_info}
                      />
                    ) : null}
                    {/* {state.userType !== "patient" ? (
                      <CustomInput
                        labelText={language.bankName + language.required}
                        id="bankName"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          required: true,
                        }}
                        onChange={onInputChange}
                        value={state.bankName}
                      />
                    ) : null} */}

                    {/* 
                    banking details - removed per request */}
                    {/* {state.userType !== "patient" ? (
                      <Autocomplete
                        id="bank-name-autocomplete"
                        options={saBanks}
                        getOptionLabel={(option) => option.label}
                        value={saBanks.find((bank) => bank.value === state.bankName) || null}
                        onChange={(event, newValue) => {
                          setState((prev) => ({
                            ...prev,
                            bankName: newValue ? newValue.value : "",
                          }));
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={language.bankName + language.required}
                            variant="outlined"
                            fullWidth
                            required
                          />
                        )}
                      />
                    ) : null}

                    {state.userType !== "patient" ? (
                      <CustomInput
                        labelText={language.bankCode + language.required}
                        id="bankCode"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          required: true,
                        }}
                        onChange={onInputChange}
                        value={state.bankCode}
                      />
                    ) : null}
                    {state.userType !== "patient" ? (
                      <CustomInput
                        labelText={language.bankAccount + language.required}
                        id="bankAccount"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          required: true,
                        }}
                        onChange={onInputChange}
                        value={state.bankAccount}
                      />
                    ) : null}
                    {state.userType !== "patient" ? (
                      <>
                        <Label>Bank Type</Label>
                        <>
                          <Select
                            id="bankType"
                            value={state.bankType}
                            onChange={handleBankType}
                            variant="outlined"
                            fullWidth
                          // className={
                          //   specialityTypes === language.select_practice
                          //     ? classes.inputdimmed
                          //     : classes.input
                          // }
                          >
                            <MenuItem value="check">Check</MenuItem>
                            <MenuItem value="savings">Savings</MenuItem>
                            <MenuItem value="credit">Credit</MenuItem>
                            <MenuItem value="debit">Debit</MenuItem>
                          </Select>
                        </>
                      </>
                    ) : null} */}



                    {state.userType === "doctor" ? (
                      <Col>
                        <Row>
                          <FormGroup>
                            {state.userType !== "patient" &&
                              state.userType !== "nurse" ? (
                              <FormText color="red" tag="header">
                                Doctor Image <em>(Only PNG and JPG files accepted. Please ensure the image is clear.)</em>
                              </FormText>

                            ) : state.userType !== "patient" &&
                              state.userType !== "doctor" ? (
                              <FormText color="red" tag="header">
                                Nurse Image<em>(Only PNG and JPG files accepted. Please ensure the image is clear.)</em>
                              </FormText>

                            ) : null}
                            <div className="fileinput text-center">
                              <input
                                type="file"
                                onChange={handleImageChange1}
                                ref={fileInput1}
                              />
                              <div className={"thumbnail" + props.avatar}>
                                <img src={imagePreviewUrl1} />
                              </div>
                              <div>
                                {fileState1 === null ? (
                                  <Button
                                    className="btn-round"
                                    onClick={() => handleClick1()}
                                  >
                                    {null ? "Add Photo" : "Upload Image"}
                                  </Button>
                                ) : (
                                  <span>
                                    <Button
                                      className="btn-round"
                                      onClick={() => handleClick1()}
                                    >
                                      Change
                                    </Button>
                                    {props.avatar ? <br /> : null}
                                    <Button
                                      color="danger"
                                      className="btn-round"
                                      onClick={() => handleRemove1()}
                                    >
                                      <i className="fa fa-times" />
                                      Remove
                                    </Button>
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </Row>
                      </Col>
                    ) : null}
                    {state.userType === "nurse" ? (
                      <Col>
                        <Row>
                          <FormGroup>
                            <FormText color="red" tag="header">
                              Nurse Image<em>(Only PNG and JPG files accepted. Please ensure the image is clear.)</em>
                            </FormText>

                            <div className="fileinput text-center">
                              <input
                                type="file"
                                onChange={handleImageChange1}
                                ref={fileInput1}
                              />
                              <div className={"thumbnail" + props.avatar}>
                                <img src={imagePreviewUrl1} />
                              </div>
                              <div>
                                {fileState1 === null ? (
                                  <Button
                                    className="btn-round"
                                    onClick={() => handleClick1()}
                                  >
                                    {null ? "Add Photo" : "Upload Image"}
                                  </Button>
                                ) : (
                                  <span>
                                    <Button
                                      className="btn-round"
                                      onClick={() => handleClick1()}
                                    >
                                      Change
                                    </Button>
                                    {props.avatar ? <br /> : null}
                                    <Button
                                      color="danger"
                                      className="btn-round"
                                      onClick={() => handleRemove1()}
                                    >
                                      <i className="fa fa-times" />
                                      Remove
                                    </Button>
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </Row>
                      </Col>
                    ) : null}
                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    <Button
                      className={classes.normalButton}
                      simple
                      color="primary"
                      size="lg"
                      onClick={handleRegister}
                    >
                      {language.register}
                    </Button>
                    <Button
                      className={classes.normalButton}
                      simple
                      color="primary"
                      size="lg"
                      onClick={handleBack}
                    >
                      {language.back}
                    </Button>
                  </CardFooter>
                </form>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
        <Footer whiteFont />
        <AlertDialog
          open={commonAlert.open}
          onClose={handleCommonAlertClose}
          title={"Alert"}
        >
          {commonAlert.msg}
        </AlertDialog>
      </div>
    </div>
  );
}
